// base
import { put, takeEvery } from 'redux-saga/effects';

// slice
import { uiActions } from '../slices/ui.slice';

// modules
import { GET_CHART_DASHBOARD_PROJECT } from 'modules/dashboard';
import { GET_USER_DOWNLOAD } from 'modules/user';
import { GET_NATION_LIST } from 'modules/nation';
import {
  GET_DESIGNATION_LIST,
  GET_DISCIPLINE_LIST,
  GET_MAIN_SYSTEM_LIST,
  GET_MULTI_SYSTEM_LIST,
  GET_SYSTEM_LIST,
  GET_SYSTEM_SUB_ALL_LIST,
  GET_SYSTEM_SUB_LIST
} from 'modules/system';
import { GET_SAFETY_SETTING } from 'modules/safety';
import { GET_WORKER_DOWNLOAD } from 'modules/worker';
import { GET_COMPANY_NAME_LIST } from 'modules/company';

function* watchAsyncActionSaga(action) {
  const returnActions = [
    GET_CHART_DASHBOARD_PROJECT,
    GET_USER_DOWNLOAD,
    GET_NATION_LIST,
    GET_DESIGNATION_LIST,
    GET_SAFETY_SETTING,
    GET_DISCIPLINE_LIST,
    GET_MAIN_SYSTEM_LIST,
    GET_SYSTEM_LIST,
    GET_SYSTEM_SUB_LIST,
    GET_SYSTEM_SUB_ALL_LIST,
    GET_MULTI_SYSTEM_LIST,
    GET_WORKER_DOWNLOAD,
    GET_COMPANY_NAME_LIST
  ];

  const shouldExclude = returnActions.some((baseAction) => action.type.includes(baseAction));

  if (shouldExclude) {
    return;
  }

  if (!/pending|fulfilled|rejected/gi.test(action.type)) {
    return;
  }

  yield put(
    uiActions.pageLoaderAction({
      actionType: action.type
    })
  );
}

export function* uiSaga() {
  yield takeEvery('*', watchAsyncActionSaga);
}
